import Timeline from './components/Timeline'
import TimelineMessage from './components/TimelineMessage'
import TimelineMessageMedia from './components/TimelineMessageMedia'

import linkify from 'vue-linkify'

export default {
	install (Vue, options) {
		Vue.component('timeline-message-media', TimelineMessageMedia)
		Vue.component('timeline-message', TimelineMessage)
		Vue.component('timeline', Timeline)
		Vue.directive('linkified', linkify)
	}
}
